export default "__VITE_ASSET__D7nk03Zu__"